import React, { FunctionComponent } from 'react';
import { LocaleIntlProvider } from './LocaleIntlProvider';

export const MeLocaleIntlProvider: FunctionComponent = ({
  children
}: {
  children?: React.ReactNode;
}) => {
  const locale = 'en-US';
  const ianaName = 'America/Los_Angeles';
  return (
    <LocaleIntlProvider locale={locale} ianaName={ianaName}>
      {children}
    </LocaleIntlProvider>
  );
};
